import { useSyncExternalStore } from 'react'

/**
 * オーナーの契約・休会の状態が変わったことを、表示中のバナーに伝える (#1689)。
 *
 * 店舗画面のバナー (`StoreSuspensionBanner` / `StoreSaasNoticeBanner`) は
 * `RequireStoreAuth` の中に置かれていて、`/store/*` の中を移動しても
 * **再マウントされない**。状態をマウント時にしか取りに行かないと、未払いを
 * 払った後も「お支払いが確認できていません」「休会中」が出続ける。
 *
 * **催告に応じて払った店に「まだ止まっている」と見せる**のは表示として誤りで、
 * もう一度払わせかねない。解除が起きうる操作 (払い直し・申込み・解約) の後に
 * `refreshOwnerBillingState()` を呼ぶ。
 *
 * 状態は「何回変わったか」だけなので、Zustand を挟まず module 変数を購読させる。
 */
const listeners = new Set<() => void>()
let revision = 0

export function refreshOwnerBillingState() {
  revision += 1
  listeners.forEach((fn) => fn())
}

function subscribe(fn: () => void) {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}

/** 取り直しの合図。effect の依存に入れて使う。 */
export function useOwnerBillingRevision(): number {
  return useSyncExternalStore(subscribe, () => revision, () => revision)
}
